import React from "react";
import { connect } from "react-redux";
import { formatNumber, formatNumberForceSigned } from "../../../lib/commonFunctions";
import LimitLine from "../../GameHeader/Stats/LimitLine";

const GoldBalance = ({ goldBalance }) => (
  <React.Fragment>
    <h3 className="title">Gold balance</h3>
      Alchemists: <span className={goldBalance.production.alchemists > 0 ? "positive" : ""}>{formatNumberForceSigned(goldBalance.production.alchemists)}</span><br/>
      Employed pops: <span className={goldBalance.production.industrials > 0 ? "positive" : ""}>{formatNumberForceSigned(goldBalance.production.industrials)}</span><br/>
      Building bonuses: <span className={goldBalance.production.buildings > 0 ? "positive" : ""}>{formatNumberForceSigned(goldBalance.production.buildings)}</span><br/>
      Building maintenance: <span className={goldBalance.consumption.buildings ? "negative" : ""}>{formatNumber(-goldBalance.consumption.buildings)}</span><br/>
      Army upkeep: <span className={goldBalance.consumption.army ? "negative" : "" }>{formatNumber(-goldBalance.consumption.army)}</span>
    <br />
    <LimitLine
      amount={goldBalance.limit.amount}
      limit={goldBalance.limit.limit}
      market={0}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  goldBalance: state.governorate.resourceBalances.gold,
});

export default connect(mapStateToProps)(GoldBalance);
